import { render } from "./componentTitle.vue?vue&type=template&id=6e6518b9&scoped=true&ts=true"
import script from "./componentTitle.vue?vue&type=script&lang=ts"
export * from "./componentTitle.vue?vue&type=script&lang=ts"

import "./componentTitle.vue?vue&type=style&index=0&id=6e6518b9&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e6518b9"]])

export default __exports__